import { Button, Grid, Typography } from "@material-ui/core";
import { useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import PurgeService from "./PurgeService";
import DefaultButton from "../../componentes/button/DefaultButton";
import { useState } from "react";
import { BaseDialog } from "../../componentes/baseComponents/base-dialog/BaseDialog";


export const Purge = (props) => {

    const { t } = useTranslation();
    const loggedUserId = sessionStorage.getItem("userId");

    const initialState = {
        idClient: 0,
        userId: loggedUserId,
        success: false,
        error: false,
        message: ""
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, ...action.data, success: true, error: false }
            case 'error':
                return { ...state, ...action.data, success: false, error: true }
            case 'close_alert':
                return { ...state, ...action.data, success: false, error: false, message: "" }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const {
        idClient,
        success,
        error,
        message,
    } = state;

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } })
    }

    const canPurge = () => idClient !== 0;

    const handlePurgeUpdate = () => {
        if (!canPurge()) {
            dispatch({ type: 'error', data: { message: t("selectCustomer") } });
            return;
        }

        openPurgeDialog(() => {
            PurgeService
                .purgeClient(state)
                .then((response) => {
                    if (response.status === 200) {
                        dispatch({ type: 'success', data: { message: t("sucessPurge") } });
                    }
                })
                .catch(() => dispatch({ type: 'error', data: { message: t("errorPurge") } }));
        });
    };

    const [purgeDialogOpen, setPurgeDialogOpen] = useState(false);
    const [onConfirmPurge, setOnConfirmPurge] = useState(null);

    const openPurgeDialog = (callback) => {
        setOnConfirmPurge(() => callback);
        setPurgeDialogOpen(true);
    };

    const closePurgeDialog = () => {
        setPurgeDialogOpen(false);
        setOnConfirmPurge(null);
    };

    const handleCloseAlertstate = () => {
        dispatch({ type: 'close_alert' });
    };

    return (
        <DefaultScreenAccordion
            title={"purge"}
            fields={
                <>
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            message={message}
                            handleCloseAlert={handleCloseAlertstate}
                            snackbar
                            autoClose
                        />
                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={3}>
                                <DefaultAutocomplete
                                    iconLabelSwitch={
                                        <IconLabelSwitch
                                            name={"user"}
                                            labelName="client"
                                        />
                                    }
                                    name="idClient"
                                    onChange={handleChange}
                                    value={idClient}
                                    defaultSize
                                    useApi
                                    endpoint='GetClientLessGeneric'
                                    error={error && idClient === 0}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <DefaultButton labelName="Expurgar" className="errorButton" onClick={handlePurgeUpdate} />
                            </Grid>

                        </GridInputRow>

                    </GridItemContainer>
                    <BaseDialog
                        open={purgeDialogOpen}
                        onClose={closePurgeDialog}
                        noButtonStyle
                        maxWidth="sm"
                        fullWidth
                        title={t("confirmPurge")}
                        actions={
                            <>
                                <DefaultButton
                                    onClick={() => {
                                        if (onConfirmPurge) {
                                            onConfirmPurge();
                                        }
                                        closePurgeDialog();
                                    }}
                                    labelName={t("yes")}
                                    className="primaryButton"
                                >
                                </DefaultButton>
                                <DefaultButton
                                    onClick={closePurgeDialog}
                                    labelName={t("no")}
                                    className="secondaryButton">
                                </DefaultButton>
                            </>
                        }
                    />

                </>
            } />
    )
}